import type { ReactNode } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// EmptyState — a reusable empty-state surface with personality.
//
// Drops the faded GG Anvil mark into the background so the empty moment
// still feels branded. Accepts optional icon + action for richer empty
// states (e.g. "No matches yet · Create one").
// ─────────────────────────────────────────────────────────────────────────────

export function EmptyState({
  title,
  message,
  icon,
  action,
}: {
  title: string;
  message?: string;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="relative flex min-h-[40vh] flex-col items-center justify-center py-16 text-center">
      {/* Dim anvil mark in the background */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.04]">
        <img src="/brand/gganvil-mark.svg" alt="" className="h-64 w-64 animate-anvil-strike" />
      </div>

      <div className="relative flex flex-col items-center gap-4">
        {icon && <div className="text-forge-500/80">{icon}</div>}
        <h2 className="font-display text-2xl font-black uppercase tracking-tight text-white">
          {title}
        </h2>
        {message && (
          <p className="max-w-md font-mono text-[11px] uppercase leading-relaxed tracking-[0.18em] text-iron-500">
            {message}
          </p>
        )}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}
